import NavBar from "./NavBar";
import ProductsByCategory from "./ProductsByCategory";
import { useEffect, useState } from "react";
import React from "react";
const Menu = (props) => {
  const categoriesName = [
    "Entrantes y Aditivos",
    "Desayunos",
    "Pizzas y Espaguetis",
    "Hamburguesas y Sandwish",
    "Tacos",
    "Bebidas",
    "Cocteles",
    "Postres",
    "Infusiones-Cafe-Te",
  ];
  const [products, setProducts] = useState([]);
  const [actualCategory, setActualCategory] = useState(0);
  const [lastAction, setLastAction] = useState("Scroll");

  useEffect(() => {
    const loadProducts = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_URL + "api/menu");

        if (!response.ok) {
          throw new Error({ message: "No se pudo cargar los productos." });
        } else {
          const data = await response.json();

          if (data.success) {
            setProducts(data.data[0]);
          } else {
            throw new Error("Error al cargar los productos");
          }
        }
      } catch (err) {
        throw err;
      }
    };

    loadProducts();
  }, []);

  const isInView = (element) => {
    const rect = element.getBoundingClientRect();
    const header = document.querySelector(".header");
    const headerHeight = header.clientHeight;
    const navBarHeight = document.querySelector("#nav-bar").clientHeight;
    const needed = headerHeight + navBarHeight;

    return (
      (rect.top > needed && rect.top < window.innerHeight) ||
      rect.bottom > needed
    );
  };

  const handleScroll = () => {
    const containers = document.querySelectorAll(".products-container");

    for (let i = 0; i < containers.length; i++) {
      if (isInView(containers[i])) {
        if (i !== actualCategory) {
          setLastAction("Scroll");
        }
        setActualCategory(i);
        return;
      }
    }
    return;
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (lastAction === "Click") {
      const navElment = document.querySelectorAll(".products-container")[
        actualCategory
      ];

      if (navElment) {
        const rect = navElment.getBoundingClientRect();
        const header = document.querySelector(".header");
        const headerHeight = header.clientHeight;
        const navBarHeight = document.querySelector("#nav-bar").clientHeight;

        let neededScroll =
          rect.top + window.scrollY - headerHeight - navBarHeight - 60;

        window.scrollTo({
          top: neededScroll,
          behavior: "smooth",
        });
      }

      setLastAction("Scroll");
    }

    let element = document.querySelectorAll(".nav-element");

    if (element) {
      let e = element[actualCategory];

      if (e) {
        const nav = document.querySelector("#nav-bar");

        const needed = e.getBoundingClientRect().x - 10; /// este 20 es el margin

        nav.scrollBy({
          left: needed,
          behavior: "smooth",
        });
      }
    }
  }, [actualCategory]);

  const filterByCategory = (category) => {
    try {
      const filteredProducts = products.filter(
        (product) => product.category === category,
      );
      return filteredProducts;
    } catch (err) {}
  };

  // TODO: use lazy loading (use React Suspense)
  return (
    <div id="menu">
      <div className="menu-container">
        <NavBar
          actualCategory={actualCategory}
          changeActualCategory={setActualCategory}
          changeActualAction={setLastAction}
        />
        <div className="menu-category">
          {products.length > 0
            ? categoriesName.map((category, index) => (
                <ProductsByCategory
                  key={category}
                  categoryName={category}
                  products={filterByCategory(category)}
                  changeActualCategory={setActualCategory}
                />
              ))
            : ""}
        </div>
      </div>
    </div>
  );
};

export default Menu;
